

import "./SubscriberProfile.css"


export default function SubscriberProfile({firstActiveSubscriptionFound}){

    const handleClick = () => {
        // Redirect user to Stripe Customer Portal
        window.location.href = "https://billing.stripe.com/p/login/test_3cI8wO9gu0PE457dkS9ws00";;
    };

    return (
        <>
            <div className="manage-subscriptions-container">
                <div className="subscrption-status-title-container">
                    Subscription: &#8239; {firstActiveSubscriptionFound !== null && firstActiveSubscriptionFound?.status === "active" && <div className="active-subscrption">Active</div>}
                </div><br/>


                {firstActiveSubscriptionFound !== null && firstActiveSubscriptionFound?.status === "active" &&
                    <>
                        <div className="charge-info">
                            
                            Renewal:  &#8239;
                            <div className="renewal-date-bold">
                                {new Date(firstActiveSubscriptionFound?.current_period_end).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric"
                                    })
                                }
                            </div>
                        </div> <br/>
                    </> 
                }

                <div className="custom-support-email">
                    Customer Support: &#8239; <div className="custom-support-email-bold"> studium93official@gmail.com </div>
                </div><br/>

                <button onClick={handleClick} className="manage-subscrption-button">
                        Manage Subscription
                </button>
                


            </div>      
        </>
    )
}